/**
 * Card component
 */

import React from 'react';
import classNames from 'classnames';

var container = function container(name) {
  return function (_ref) {
    var children = _ref.children,
        className = _ref.className;
    return React.createElement(
      'div',
      { className: classNames(name, className) },
      children
    );
  };
};

export var Card = container('mdc-Card');
export var Actions = container('mdc-Card-actions');
export var Title = container('mdc-Card-title');
export var Text = container('mdc-Card-text');
export var Content = container('mdc-Card-content');


//////////////////
// WEBPACK FOOTER
// ../es/js/card/index.js
// module id = 283
// module chunks = 0